module.exports = __webpack_public_path__ + "img/reward-top-bg-zh.5abdc3b0.png";